<template>
  <CustomModal ref="modal" title="Supprimer le groupe">
    <div v-if="group" class="content">
      <p class="warning">
        <span class="fas fa-triangle-exclamation"></span>
        Cette action est <strong>définitive et irréversible</strong> : aucune sauvegarde n'est conservée.
      </p>
      <p>Le groupe <strong>{{ group.name }}</strong> et tout ce qui lui appartient seront supprimés :</p>
      <ul>
        <li>le groupe et ses options ;</li>
        <li>ses {{ group.userCount }} utilisateur(s) et leurs comptes de connexion, ainsi que l'historique de connexions ;</li>
        <li>les clients, contrats, devis, factures, acomptes, avoirs et encaissements ;</li>
        <li>les fournisseurs, achats et décaissements ;</li>
        <li>les commandes de production ;</li>
        <li>les données de facturation électronique (entreprise, annuaire, autorisations).</li>
      </ul>
      <p>Pour confirmer, saisissez le nom du groupe : <strong>{{ group.name }}</strong></p>
      <CustomTextField :content=confirmation />
    </div>
    <div class="button-container">
      <CustomForm ref="form" :inputs=[] :submit=buttons.submit>
        <CustomButton class="danger" @click="submitForm" :params=buttons.submit />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import CustomForm from "@/components/forms/CustomForm.vue";
import {NotificationService} from "@vues/v-common";
import {AdministrationController} from "@/administration/controllers/AdministrationController";
library.add(faTriangleExclamation);

/**
 * Suppression définitive d'un groupe et de toutes ses données : le nom du groupe doit être saisi pour confirmer.
 * callback : appelé une fois le groupe supprimé.
 */
export default {
  name: 'DeleteGroupModal',
  props: ['callback'],
  components: {CustomForm, CustomModal, CustomButton, CustomTextField},
  data() {
    return {
      group: undefined,
      confirmation: {label: 'Nom du groupe', value: '', type: 'text'},
      buttons: {
        submit: {text: "Supprimer définitivement", disabled: true},
      },
    };
  },
  watch: {
    "confirmation.value"(value) {
      this.buttons.submit.disabled = !this.isConfirmed(value);
    },
  },
  methods: {
    isConfirmed(value) {
      return !!this.group && String(value ?? '').trim() === this.group.name;
    },
    openModal(group) {
      this.group = group;
      this.confirmation.value = '';
      this.buttons.submit.disabled = true;
      this.$refs.modal.openModal();
    },
    closeModal(event = false) {
      this.$refs.modal?.closeModal(event);
    },
    async submitForm() {
      if (!this.isConfirmed(this.confirmation.value)) return;

      const res = await this.$refs.form.submitForm(() => AdministrationController.deleteGroup(this.group.id));
      if (!res.errors) {
        (new NotificationService).addNotification("success", `Groupe « ${this.group.name} » supprimé`);
        this.closeModal(true);
        this.callback();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.content
  padding 0 40px

  p, ul
    margin 0 0 12px

  ul
    padding-left 20px
    font-size 13.5px

.warning
  padding 10px 14px
  color CTRL_ERROR
  background CTRL_ERROR_BG
  border 1px solid CTRL_ERROR
  border-radius 6px

.button-container
  display flex
  justify-content center
  padding 20px 0 40px

  form
    align-items center

  // Irreversible action : the button is red
  .danger
    width 220px

    :deep(button.enabled)
      background-color CTRL_ERROR
</style>
